import React from 'react'
import { useTheme, Stack } from '@mui/material'
import { LinkButton } from '@e3dc-react/shell/Elements/Buttons'
import { AccessRightOptions } from 'src/Routes/Installation/InstallationModel'
import useModals from 'src/Hooks/useModals'
import { InstallationWithoutAccess } from 'src/Libs/installations/models'
import NoInstallationIdTooltip from 'src/Elements/Installations/NoInstallationIdTooltip'
import { getInstallationWithoutAccessOwnerName } from 'src/Libs/installations/utils'

interface Props {
  installation: InstallationWithoutAccess
  linkClassName?: string
}

/**
 * Clickable installationID for installations without access
 * user can request access to installation owner by clicking on the installationID
 */
const InstallationLink: React.FC<Props> = ({ installation, linkClassName }) => {
  const theme = useTheme()
  const { openInstallationAccessRequestDialog } = useModals()
  const { id, permissionType, accessRequestAt, accountLinkId, deviceId } = installation

  const hasInstallationId = !!id

  const isLinkDisabled = !hasInstallationId || permissionType === AccessRightOptions.blocked

  const onLinkTarget = (): void => {
    if (!hasInstallationId) return

    const installationId = id
    /* serialNumber,  emsMasterDeviceId, deviceId are all same thing */
    const storageId = deviceId
    const owner = getInstallationWithoutAccessOwnerName(installation)
    openInstallationAccessRequestDialog({ installationId, accountLinkId, storageId, owner, permissionType, accessRequestAt })
  }

  if (!hasInstallationId) {
    return <NoInstallationIdTooltip />
  }

  return (
    <Stack flexDirection="row">
      <Stack justifyContent="center">
        <Stack direction="row" alignItems="center" gap={1}>
          <LinkButton
            linkClassName={linkClassName}
            content={id}
            linkColor={theme.palette.primary.main}
            hasUnderline={false}
            onClick={onLinkTarget}
            clickable={!isLinkDisabled}
            dataQa={`button-installation-id-${id}`}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}

export default InstallationLink
